/**
 * Helper functions for domain text truncation
 */

// Buffer to prevent text from being cut off due to rounding errors or font rendering differences
export const ELLIPSIS_BUFFER_PX = 35;

// Domain structure returned by parseDomain

export const debounce = (func, wait) => () => {
  let timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};
const DomainTruncationHelpers = {
  /**
   * Performs binary search to find optimal character counts for front and back parts
   */
  findOptimalFit: (sld, subdomainPart, tldPart, availableWidth, measureTextWidth) => {
    let frontChars = 0;
    let backChars = 0;
    let low = 1;
    let high = Math.floor(sld.length / 2);

    // Find balanced front/back characters that fit within available width
    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const testText = `${subdomainPart}${sld.slice(0, mid)}...${sld.slice(sld.length - mid)}${tldPart}`;
      const testWidth = measureTextWidth(testText);
      if (testWidth <= availableWidth) {
        frontChars = mid;
        backChars = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    // Optimize front characters
    let testFront = frontChars;
    let testBack = backChars;
    while (testFront < sld.length - backChars) {
      const testText = `${subdomainPart}${sld.slice(0, testFront + 1)}...${sld.slice(sld.length - backChars)}${tldPart}`;
      if (measureTextWidth(testText) > availableWidth) {
        break;
      }
      testFront++;
    }

    // Optimize back characters
    while (testBack < sld.length - testFront) {
      const testText = `${subdomainPart}${sld.slice(0, testFront)}...${sld.slice(sld.length - testBack - 1)}${tldPart}`;
      if (measureTextWidth(testText) > availableWidth) {
        break;
      }
      testBack++;
    }

    // Ensure at least one character on each side
    return {
      frontChars: Math.max(1, testFront),
      backChars: Math.max(1, testBack)
    };
  },
  /**
   * Creates a minimal representation for extremely constrained widths
   */
  createMinimalDomainRepresentation: (sld, subdomain, tldPart) => {
    return `${subdomain ? `${subdomain}.` : ''}${sld[0]}...${sld[sld.length - 1]}${tldPart}`;
  },
  /**
   * Creates the truncated domain representation
   */
  createTruncatedDomainText: (sld, subdomainPart, tldPart, frontChars, backChars) => {
    return `${subdomainPart}${sld.slice(0, frontChars)}...${sld.slice(sld.length - backChars)}${tldPart}`;
  }
};
export default DomainTruncationHelpers;
//# sourceMappingURL=DomainTruncationHelpers.js.map